var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#009FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.25H12.75V8C12.75 7.59 12.41 7.25 12 7.25C11.59 7.25 11.25 7.59 11.25 8V11.25H8C7.59 11.25 7.25 11.59 7.25 12C7.25 12.41 7.59 12.75 8 12.75H11.25V16C11.25 16.41 11.59 16.75 12 16.75C12.41 16.75 12.75 16.41 12.75 16V12.75H16C16.41 12.75 16.75 12.41 16.75 12C16.75 11.59 16.41 11.25 16 11.25Z",
    fill: "#009FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7251 24C20.3987 24 20.1478 23.7109 20.1938 23.3877L21.1795 16.4611C21.2171 16.1965 21.4436 16 21.7108 16C22.0372 16 22.2881 16.2891 22.2421 16.6123L21.2565 23.5389C21.2188 23.8035 20.9923 24 20.7251 24ZM17.7212 22.0156C17.3407 22.0156 17.0484 21.6784 17.1025 21.3018C17.1467 20.9941 17.4103 20.7656 17.7212 20.7656H21.879C22.2596 20.7656 22.5518 21.1028 22.4977 21.4795C22.4535 21.7872 22.1899 22.0156 21.879 22.0156H17.7212ZM18.2858 24C17.9594 24 17.7085 23.7109 17.7545 23.3877L18.7402 16.4611C18.7778 16.1965 19.0043 16 19.2715 16C19.5979 16 19.8488 16.2891 19.8028 16.6123L18.8172 23.5389C18.7795 23.8035 18.553 24 18.2858 24ZM18.1195 19.2344C17.7383 19.2344 17.4459 18.8961 17.5011 18.5189C17.546 18.2119 17.8093 17.9844 18.1195 17.9844H22.2769C22.6581 17.9844 22.9505 18.3227 22.8953 18.6999C22.8504 19.0068 22.5871 19.2344 22.2769 19.2344H18.1195Z",
    fill: "#C5CEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedSection);
export default __webpack_public_path__ + "static/media/created-section.f0be43a741ade85ae84051bd721c06ac.svg";
export { ForwardRef as ReactComponent };